import { render, staticRenderFns } from "./McTime.vue?vue&type=template&id=4b684bae&scoped=true"
import script from "./McTime.vue?vue&type=script&lang=js"
export * from "./McTime.vue?vue&type=script&lang=js"
import style0 from "./McTime.vue?vue&type=style&index=0&id=4b684bae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b684bae",
  null
  
)

export default component.exports